// Firebase actualizado a la versión 9
// Selección de proyecto por REACT_APP_ENV:
//   - "staging"   → plataforma-testing (frontend desplegado en staging.imova.cl)
//   - otro/unset  → reporteria-web (productivo, default)
// La config web de Firebase es pública (no es secreto); las reglas de seguridad
// son las que protegen los datos.

const PROD = {
  apiKey: "AIzaSyAtPJ1OoBcv21c4c_AD-yF3zfaQxhg6Jsk",
  authDomain: "reporteria-web.firebaseapp.com",
  databaseURL: "https://reporteria-web.firebaseio.com",
  projectId: "reporteria-web",
  storageBucket: "reporteria-web.appspot.com",
  messagingSenderId: "824245382613",
  appId: "1:824245382613:web:07b8790c74c43e52",
  measurementId: "G-LRZ6CML97Y"
};

const STAGING = {
  apiKey: "AIzaSyDzaDdv_Q0ViK-dE3-0Y65sGRrfPYLWg5s",
  authDomain: "plataforma-testing.firebaseapp.com",
  databaseURL: "https://plataforma-staging.firebaseio.com",
  projectId: "plataforma-testing",
  storageBucket: "plataforma-testing.appspot.com",
  messagingSenderId: "650165639832",
  appId: "1:650165639832:web:3af3045de4de63c3f20eed",
  measurementId: "G-4M2R9NPYGT"
};

const env = (process.env.REACT_APP_ENV || "").trim();
const FirebaseConfig = env === "staging" ? STAGING : PROD;
if ((process.env.REACT_APP_DEBUG_LOGS || "").trim() === "true") {
  console.log(`[FirebaseConfig] env="${env}", projectId=${FirebaseConfig.projectId}`);
}

export default FirebaseConfig;
